var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 66,
    viewBox: "0 0 65 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 68453"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 68452"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1002",
    cx: 32.5,
    cy: 32.8298,
    r: 32.5,
    fill: "#AAAAAA"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2656 28.8424V29.4699C19.2656 32.5335 20.3144 35.506 22.2395 37.8982L32.2054 50.2833L42.1715 37.8982C44.0965 35.506 45.1453 32.5335 45.1453 29.4699V28.8424C45.1453 21.7375 39.3519 15.9778 32.2054 15.9778C25.059 15.9778 19.2656 21.7375 19.2656 28.8424ZM32.2054 33.1306C34.5876 33.1306 36.5187 31.2107 36.5187 28.8424C36.5187 26.4741 34.5876 24.5542 32.2054 24.5542C29.8233 24.5542 27.8922 26.4741 27.8922 28.8424C27.8922 31.2107 29.8233 33.1306 32.2054 33.1306Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/Address.36ff5af0f82cd62296b952d91806e72d.svg";
export { ForwardRef as ReactComponent };